module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_03.427693b6.jpg";